@if (shouldShow$ | async) {
  <nav
    class="pt-12 md:pt-[4.5rem] pb-2 breadcrumb-container"
    aria-label="Breadcrumb"
    >
    <ol
      class="flex items-center gap-1 m-0 py-2 px-2 text-xs md:bg-white/10 md:border md:border-white/20 md:backdrop-blur-md md:backdrop-saturate-180 md:rounded-xl w-full md:w-fit max-w-full pointer-events-auto font-apple hover:border-white/25 overflow-hidden"
      >
      <li class="crumb home flex items-center flex-shrink-0">
        <a
          routerLink="/"
          class="text-white/95 no-underline font-medium transition-colors duration-150 hover:text-white hover:underline flex items-center"
          >Home</a
          >
        </li>
        @if (crumbs$ | async; as crumbs) {
          @for (c of crumbs; track c; let last = $last) {
            <li
              class="text-white/60 font-light flex items-center flex-shrink-0"
              aria-hidden="true"
              >
              /
            </li>
            <li class="crumb flex items-center min-w-0" [class.current]="last">
              @if (!last) {
                <a
                  [routerLink]="c.url"
                  class="text-white/95 no-underline font-medium transition-colors duration-150 hover:text-white hover:underline block whitespace-nowrap overflow-hidden text-ellipsis min-w-0 max-w-[15ch] md:max-w-none"
                  [title]="c.label"
                  >{{ c.label }}</a
                  >
                }
                @if (last) {
                  <span
                    class="text-white/85 font-medium whitespace-nowrap overflow-hidden text-ellipsis block min-w-0 flex-1 max-w-[20ch] md:max-w-none"
                    [title]="c.label"
                    >{{ c.label }}</span
                    >
                  }
                </li>
              }
            }
          </ol>
        </nav>
      }
